import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography, Link } from '@mui/material';
import LaunchSharpIcon from '@mui/icons-material/LaunchSharp';

import { trackHeaderFooterClick } from '../segment/segmentModule';
import { getIsOldUiPreferred } from '../app/bootstrap';

export const CashstarLink = ({
    linkText,
    url,
    trackExternalLinkClickAction
}) => {
    const enableNewUI = !getIsOldUiPreferred();
    const onClick = () => trackExternalLinkClickAction('Footer Link Click',
        { title: linkText, path: url });
    const linkProps = {
        href: url,
        onClick,
        target: '_blank',
        rel: 'noopener noreferrer'
    };

    return (
        <Link {...linkProps}>
            <Typography
                className={`footer-grid-item ${enableNewUI ? 'footer-grid-item-new' : ''}`}
            >
                {linkText}
                {enableNewUI && (
                    <LaunchSharpIcon
                        className="footer-external-link"
                        titleAccess="- opens in a new window"
                    />
                )}
            </Typography>
        </Link>
    );
};


CashstarLink.propTypes = {
    
    linkText: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    
    trackExternalLinkClickAction: PropTypes.func.isRequired
};

export default connect(
    null,
    { trackExternalLinkClickAction: trackHeaderFooterClick }
)(CashstarLink);
